<template>
  <div class="details" style="background: #f3f3f3">
    <headbox class="listhead"></headbox>
    <div class="assreboxo">
      <!-- <p>
        当前位置：<router-link to="/zthd?id=10" v-if="geththd">专题活动&nbsp;>&nbsp;</router-link>
        <router-link to="/cyzc?id=12" v-if="getcyzc">产业政策&nbsp;>&nbsp;</router-link>
        <router-link to="/cyfw?id=15" v-if="getcyfw">产业服务&nbsp;>&nbsp;</router-link>
      </p> -->
    </div>
    <div class="searchbox">
      <div class="searl">
        <el-menu :default-active="activeNames" :default-openeds="zhankaiNames" background-color="#fff" text-color="#0086e3" active-text-color="#fff">
          <Submenu :menuList="menu_List"></Submenu>
        </el-menu>
        <!-- <el-collapse v-for="(item,index) in menu_List" :key="index" v-model="activeNames" >
          <div @click.stop="switchMenu(item)" >
            <el-collapse-item  :name="item.id">
              <template slot="title" class=".el-collapse-item__header.is-active">
                {{item.name}}
              </template>
              <div class="asideMenu">
                  <div v-for="(items,indexs) in item.subCates" :class='[items.id == form.cate_id ? refname : ""]' :key="indexs" @click.stop="switchMenu(items)">
                    <span class="iconfont icon-zuzhizhankai"></span>
                    {{items.name}}
                  </div>
                </div>
            </el-collapse-item>
          </div>
        </el-collapse> -->
      </div>
      <!-- <list class="listRight"></list> -->
      <div class="seabl">
            <div class="seabluls">
              <ul>
                <li class="seazxlis" v-for="item in afflist" v-bind:key="item.id" >
                  <router-link :to="'/show?id=' + item.id + '&url=' + urlname + '&title=' + title">
                  <div class="sealisr">
                    <div :class="item.istop ? 'sealcol' : 'sealsrtit'">
                      <img src="../assets/images/tfzd.png" style="width: 12px;float:left;margin:5px 5px 0 0 ;" alt="" v-if="item.istop" />
                      <!-- :class="item.istop ? 'sealtdm one-line' : 'sealsrtit1 one-line'" -->
                      <div  class="sealsrtit1 one-line" v-html="item.title"></div>

                      <div class="sealtsj">
                        <!-- <div v-if="item.istop" class="seazd">置顶</div> -->
                        {{ item.createTime }}
                      </div>
                    </div>
                    <!-- v-html="item.content" -->
                    <!-- <div class="sealtct two-line">
                      {{ item.summary | ellipsis("&nbsp;") }}
                    </div> -->

                    <div class="sealtct two-line" v-if="item.summary">{{ item.summary | ellipsis }}</div>
                    <div class="sealtct two-line" v-else>{{ item.content | ellipsis }}</div>
                  </div>
                  </router-link>
                </li>
              </ul>
            </div>

            <div class="seablym">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="form.page"
                :page-size="10"
                layout="prev, pager, next, jumper"
                :total="this.total"
              >
              </el-pagination>
            </div>
            <!-- <div class="seabxxfy">
              <el-pagination
                small
                layout="prev, pager, next"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="form.page"
                :page-size="10"
              >
              </el-pagination>
            </div> -->
          </div>
    </div>
    <footbox class="listfoot"></footbox>
  </div>
</template>
<script>
import moment from "moment/moment";
import headbox from "../components/head.vue";
import footbox from "@/components/footer.vue";
// import listleft from "@/components/listleft.vue";
import list from "../views/list.vue";
import { news,MenuList } from "@/api/index.js";
import { $fmtTime } from "@/utils/utils.js";
import Submenu from '@/views/submenu.vue'

export default {
  name: "details",
  filters: {
    ellipsis(value) {
     if (value.match(/[\u4e00-\u9fa5]/g)) {
        value = value.match(/[\u4e00-\u9fa5]/g).join('');
      } else {
        return;
      }
      // 不为空将显示字数小于90个
      if (value.length > 100) {
        return value.slice(0, 100) + '...';
      }
      return value;
    },
    ellipsis2(value) {
      // 正则去除html标签
      value = value.replace(/<[^>]+>/g, "");
      // 判断是否为空
      if (!value) return "";
      // 不为空将显示字数小于90个
      if (value.length > 40) {
        return value.slice(0, 40) + "...";
      }
      return value;
    },
  },
  data() {
    return {
      form: {
        siteid: 5,
        cate_id: '',
        online: 1,
        enabled: 1,
        english: 0,
        page: 1,
        limit: 10,
      },
      total: 0,
      // 时政要闻
      afflist: [],
      urlname: this.$route.path,
      title: document.title,
      // 专题活动
      geththd: false,
      // 产业政策
      getcyzc: false,
      // 产业服务
      getcyfw: false,
      // 一级特殊栏目
      gettslm: true,
      menu_List:'',
      activeNames:'',
      zhankaiNames:[],
      refname:'zhankai',
    };
  },
  components: {
    headbox,
    footbox,
    list,
    Submenu
  },
  created() {
    let url = window.location.href
    if (url.indexOf("?") != -1) { //判断是否有参数
      this.form.cate_id = url.substr(1).split('?')[1].split('&')[0].split('=')[1]
      this.getList();
      this.zhankaiNames.push(this.form.cate_id)
      this.activeNames=this.form.cate_id
    }
    this.getList();
    this.getMenuList()
  },
  methods: {
    handlelitxq(id) {
      let goUrl = this.$router.resolve({ path: "show", query: { id: id, url: this.urlname, title: this.title } });
      window.open(goUrl.href, '_blank');
    },
    getMenuList() {
      MenuList({siteId:5}).then(res => {
        this.menu_List = res.data.data
      })
    },
    // 获取时政要闻数据
    getList() {
      news(this.form).then(res => {
        this.afflist = res.data.data.records;
        this.total = res.data.data.total;
        this.afflist.forEach(item => {
          item.createTime = moment(item.createTime).format('YYYY-MM-DD');
        });
      });
    },
    switchMenu(e) {
      let id = e.id
      this.form.cateid = e.id
      if(e.id == 100) {
        let url = this.$router.resolve({ path: "/cdgk", query: { id } });
        window.open(url.href,'_blank')
      }else if(e.id == 101) {
        let url = this.$router.resolve({ path: "/fzhj", query: { id } });
        window.open(url.href,'_blank')
      }else if(e.subCates == undefined || e.subCates.length == 0 ) {
        // 一级菜单直接跳转页面
        let goUrl = this.$router.resolve({path:'/details',query: {id:id}})
        window.open(goUrl.href,'_blank')
      }else{
      }
    },
    handleSizeChange(val) {
      this.form.limit = val;
      this.getList()
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getList()
    },
  },
  computed: {
    time() {
      return $fmtTime;
    },
  },
};
</script>
<style lang="less" scoped>

// .list {
//   // min-width: 500px;
// }
.listleft {
  width: 20%;
  margin-top: 10px;
  // float: left;
  @media screen and (max-width: 900px) {
    display: none;
  }
}
.headbox{
  position: sticky;
  top: -103px;
}
// .listhead {
//   // min-width: 500px;
// }
// .listfoot {
//   // min-width: 500px;
// }
.searchbox {
  max-width: 1200px;
  // min-width: 500px;
  margin: 0 auto;
  background: #fff;
  display: flex;
  text-align: left;
}
.seabl {
  // flex: 3;
  width:75%;
  color: #525252;
  font-family: PingFang SC-Light;
  // margin-right: 48px;
  @media screen and (max-width:900px) {
    width:100%;
  }
}
.seabluls{
  padding: 0 20px;
}
.searl {
  // flex: 1;
  width:25%;
  padding: 20px 20px 0 10px;
  @media screen and (max-width:800px) {
    display: none;
  }
}
.seablzj {
  color: #525252;
  margin: 15px 0 15px 0;
}
.seablzj > p > a {
  color: #ff9900;
}
.seablzj > p > span {
  color: #ff9900;
}
.seablzj > p > span > a {
  color: #ff9900;
}
.seazxlis {
  display: flex;
  border-bottom: 2px dashed #c1c1c1;
  margin-right: 15px;
  margin: 15px 0;
}
.seazxlis:first-child{
  padding-top:15px;
  margin: 0;
}
.sealisl {
  flex: 2;
}
.sealisr {
  // flex: 17;
  width: 873px;
  cursor: pointer;
  @media screen and (max-width: 1199px) {
    width: 100%;
  }
  @media screen and (max-width: 900px) {
    width: 100%;
  }
}
.sealisl > span {
  color: #ff9900;
  background: #fff3de;
  padding: 2px 5px 2px 5px;
}
.sealtdm {
  font-weight: 600;
  font-size: 16px;
  float: left;
  max-width: 710px;
  color: #ff9900;
  width: 80%;
}
.sealsrtit1 {
  font-weight: 600;
  font-size: 16px;
  color: #1a1a1a;
  font-weight: 600;
  max-width: 710px;
  width: 80%;
  float: left;
  @media screen and (max-width: 900px) {
    width: 95%;
  }
  @media screen and (max-width: 420px) {
    width: 90%;
  }
}
.sealsrtit1:hover{
  color:#ff9900
}
.seazd {
  color: #ff9900;
  border: 1px solid #ff9900;
  font-size: 14px;
  width: 39px;
  height: 22px;
  display: inline-table;
  line-height: 22px;
  text-align: center;
  margin-left: 5px;
}
.sealtsj {
  float: right;
  color: #8d8d8d;
  font-size: 13px;
  width: 152px;
  text-align: right;
  @media screen and (max-width: 900px) {
    display: none;
  }
}
.sealsrtit {
  color: #1a1a1a;
  font-weight: bold;
  display: flex;
  width: 100%;
}
.sealtct {
  font-size: 15px;
  color: #7a7a7a;
  margin: 10px 0 15px 0;
  width: 100%;
}
.seablym {
  margin: 50px 70px 50px 70px;
  color: #525252;
  text-align: center;
  @media screen and (max-width: 600px) {
    display: none;
  }
}
.seabxxfy {
  display: none;
  @media screen and (max-width: 600px) {
    display: block;
    text-align: center;
    padding: 30px 0 50px 0;
  }
}

.seablym > span {
  border: 1px solid #c4c4c4;
  padding: 5px 13px;
  font-size: 13px;
}
.clkcor {
  color: #fff;
  background: #ff9900;
  border: 0;
}
.fistsp {
  color: #c4c4c4;
  margin-left: 13px;
}
.clkinp {
  margin: 0 5px;
}
.clkinp > input {
  width: 22px;
  height: 20px;
  border: 0;
  outline: none;
}
.serbtn {
  background: #ff9900;
  color: #fff;
  font-size: 24px;
  height: 46px;
  line-height: 46px;
  display: block;
  font-family: PingFang SC-Regular;
  padding-left: 15px;
}
@media screen and(max-width:900px) {
  .searchbox {
    display: block;
  }
  .serbtn {
    width: 98px;
    font-size: 16px;
    background: #0086e3;
    height: 36px;
    line-height: 36px;
  }
  .seabl {
    margin: 0 15px;
  }
  .searl {
    border-bottom: 1px solid #e1e1e1;
    margin: 20px 0 0 0 !important;
  }
  .seablym {
    width: 500px;
    margin: 0 auto;
    padding: 15px 0;
    color: #525252;
  }
}
.sealcol {
  color: #1a1a1a;
  font-weight: 600;
  // display: flex;
  overflow: hidden;
  // justify-content: space-between;
}
.sealtcol {
  color: red;
  margin: 10px 0 15px 0;
}
.seasjcol {
  float: right;
  color: #1a1a1a;
  font-size: 13px;
}
.assreboxo{
  max-width:1200px;
  margin:0 auto;
  font-family: PingFang SC-Regular;
  font-size: 16px;
  background: #fff;
  padding:15px 30px;
  text-align: left;
  @media screen and (max-width:800px){
    display: none;
  }
}
.assreboxo >p{
  max-width:1200px;
  margin:0 auto;
}
.assreboxo >p >a {
  color: #000;
}
.asideBox {
  max-width: 1200px;
  // min-width: 350px;
  margin: 0 auto;
  display: flex;
  text-align: left;
  background: #fff;
}
.conulbox{
  margin-bottom:30px
  ul >li {
    font-size 14px
      padding:15px 15px 0px 15px !important;
      margin:0 !important;
      // padding-bottom: 10px;
      border-bottom: 1px dashed #C1C1C1;
      cursor: pointer;
      color:#9a9a9a

  }
}
/deep/.el-icon-arrow-right {
  display: none!important;
}
.asideMenu div {
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding-left: 45px;
  cursor: pointer;
}
.asideMenu div:hover {
  background-color: #0086e3;
  color: #fff;
}
.zhankai {
  background-color:#0086e3!important;
  color: #fff!important;
}
/deep/.el-collapse-item__header.is-active {
  background-color:#0086e3!important;
  color: #fff!important;
}
.el-menu-item.is-active {
  background-color: #0086e3!important;
}
.el-menu-item {
  border-top: 1px solid #0086e3;
  border-left: 1px solid #0086e3;
  border-right: 1px solid #0086e3;
  // margin-bottom: 15px;
}
</style>

<style>
.el-pager li{
  font-weight: normal !important;
}
.active{
  background: #0086e3 !important;
  color:#fff !important
}
</style>